import { useState, useCallback } from "react";

export const fmt = (d) => d.toISOString().split("T")[0];
export const today = () => fmt(new Date());
export const parseDate = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d, 12, 0, 0);
};
export const displayDate = (s) =>
  parseDate(s).toLocaleDateString("en-GB", {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
  });

export function useStorage(key, init) {
  const [data, setData] = useState(() => {
    try {
      const r = localStorage.getItem(key);
      return r ? JSON.parse(r) : init;
    } catch { return init; }
  });
  const save = useCallback((val) => {
    setData(val);
    try { localStorage.setItem(key, JSON.stringify(val)); } catch {}
  }, [key]);
  return [data, save];
}